<template>
  <div class="firstPage">
    <template v-for="(item, index) in list" :key="index">
      <div class="page">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <div class="content">
            <h2>{{ item.sub_category.name }}</h2>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
            <h1>
              {{ item.title }}
            </h1>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.firstPage {
  display: grid;
  grid-template-areas:
    "content1 content2 content2 content3 content4 content5"
    "content6 content2 content2 content7 content8 content8";
  font-family: "Montserrat", sans-serif;
  height: 24.479vw;
  h1 {
    font-size: 0.9vw;
    line-height: 1.267vw;
    font-weight: 700;
  }
  h2 {
    font-size: 0.833vw;
    line-height: 1.042vw;
    font-weight: 600;
  }
  h3 {
    font-size: 0.833vw;
    line-height: 1.042vw;
    font-weight: 500;
  }
  .page {
    position: relative;
    background: var(--black);
    .img {
      width: 100%;
      height: 100%;
      opacity: 0.5;
    }
    .content {
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: absolute;
      bottom: 0;
      padding-bottom: 0.5vw;
      padding-left: 0.7vw;
      pointer-events: none;
      h2 {
        position: absolute;
        top: 0.521vw;
        right: 0.521vw;
      }
    }
    &:nth-child(1) {
      grid-area: content1;
    }
    &:nth-child(2) {
      grid-area: content2;
    }
    &:nth-child(3) {
      grid-area: content3;
    }
    &:nth-child(4) {
      grid-area: content4;
    }
    &:nth-child(5) {
      grid-area: content5;
    }
    &:nth-child(6) {
      grid-area: content6;
    }
    &:nth-child(7) {
      grid-area: content7;
    }
    &:nth-child(8) {
      grid-area: content8;
    }
  }
}

@media screen and (max-width: 1366px) {
  .firstPage {
    display: grid;
    grid-template-areas:
      "content1 content2"
      "content3 content4"
      "content5 content6"
      "content7 content8";
    font-family: "Montserrat", sans-serif;
    height: 112.76vw;
    h1 {
      font-size: 2vw;
      line-height: 2.4vw;
      font-weight: 700;
    }
    h2 {
      font-size: 1.7vw;
      line-height: 2.214vw;
      font-weight: 600;
    }
    h3 {
      font-size: 1.7vw;
      line-height: 2.214vw;
      font-weight: 300;
    }
    .page {
      position: relative;
      background: var(--black);
      .img {
        width: 100%;
        height: 100%;
        opacity: 0.5;
      }
      .content {
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: absolute;
        bottom: 0;
        padding-bottom: 0.5vw;
        padding-left: 0.7vw;
        pointer-events: none;
        h2 {
          position: absolute;
          top: 0.521vw;
          right: 0.521vw;
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .firstPage {
    display: grid;
    grid-template-areas:
      "content1 content2"
      "content3 content4"
      "content5 content6"
      "content7 content8";
    background: var(--second-bg);
    height: max-content;
    h1 {
      font-size: 3.2vw;
      line-height: 4vw;
      font-weight: 600;
    }
    h2 {
      font-size: 2.667vw;
      line-height: 3.467vw;
      font-weight: 600;
    }
    h3 {
      font-size: 2.667vw;
      line-height: 3.467vw;
      font-weight: 300;
    }
    .page {
      width: 38.164vw;
      height: 57vw;
      margin-top: 8.454vw;
      margin-left: 5.623vw;
      background: transparent;
      .img {
        width: 38.164vw;
        height: 32.609vw;
        opacity: 1;
      }
      .content {
        font-family: "Open Sans", sans-serif;
        top: 34vw;
        left: 0;
        width: 100%;
        height: 100%;
        color: #000;
        display: flex;
        flex-direction: column-reverse;
        h2 {
          position: absolute;
          top: -37.5vw;
          left: 0;
        }
        h1 {
          margin-bottom: 1vw;
        }
      }
    }
  }
}
</style>